import { render, staticRenderFns } from "./AuthorProfile.vue?vue&type=template&id=d7aae7c8&"
import script from "./AuthorProfile.vue?vue&type=script&lang=js&"
export * from "./AuthorProfile.vue?vue&type=script&lang=js&"
import style0 from "./AuthorProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports